import React, { useState, useEffect, useContext } from 'react';
// import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Icon, { UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Avatar, Badge } from 'antd';
import './dropdown.css';
import { LogOut } from '../svg/sidebar';
import { customBaseUrl, httpDelete, httpGet } from '../../store/http';
import { ProfileContext } from '../../store/context/ProfileContext';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';
import slugs from '../../resources/slugs';
import { clearStorage } from '../../services/helpers';

const TopNavDropDown = () => {
  const [count, setCount] = useState(1);
  const profileName = localStorage.getItem('fullName');
  
  // const data = JSON.parse(localStorage.getItem('data'));
  const logout = (e) => {
    clearStorage();
    window.location.href = slugs.login;
  };

  const addCount = () => {
    setCount(1);
  };

  const menu = (
    <Menu selectable={false} style={{}}>
      <Menu.Item>
        <Link to={`/admin/profile/${localStorage.getItem('userId')}`}>
          <div
            style={{
              display: 'flex',

              alignItems: 'center',
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '17px',
              color: '#000000',
              marginLeft: '20px',
              marginRight: '20px',
              marginTop: '5px',
              marginBottom: '5px',
            }}
          >
            <UserOutlined
              style={{
                fontSize: '14px',
                lineHeight: '17px',
                color: '#000000',
                marginRight: '11.25px',
              }}
            />
            <div> Edit profile</div>
          </div>
        </Link>
      </Menu.Item>

      <Menu.Item>
        <a href='/#' onClick={logout}>
          <div
            style={{
              display: 'flex',

              alignItems: 'center',
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '17px',
              color: '#FF0505',
              marginLeft: '20px',
              marginRight: '20px',
              marginTop: '5px',
              marginBottom: '5px',
            }}
          >
            <Icon
              component={LogOut}
              style={{
                fontSize: '14px',
                lineHeight: '17px',
                color: '#000000',
                marginRight: '11.25px',
              }}
            />
            <div> Log Out</div>
          </div>
        </a>
      </Menu.Item>
    </Menu>
  );
  return (
    <>    
    <Dropdown overlay={menu} trigger={['click']} onVisibleChange={addCount}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
        className='h-dropdown'
      >
        <Badge >
          <Avatar shape='circle' size='large' icon={<UserOutlined />} />
        </Badge>
        <div
          style={{
            marginLeft: '10px',
          }}
        >
          {profileName}
        </div>
      </div>
    </Dropdown>
    </>

  );
};

export default TopNavDropDown;
